/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { Button } from '@mui/material';
import DefaultModal from './DefaultModal';
import Styles from '../../css/modals/CertifyModal.module.css';
import { useResetPasswordContext } from '../../contexts/ResetPasswordContext';

const ResetPasswordModal = () => {
  const resetPasswordContext = useResetPasswordContext();

  return (
    <DefaultModal
      open={resetPasswordContext.resetPasswordModalOpen}
      title={''}
      content={
        <section className={Styles.container}>
          <p className={Styles.boldText}>
            This website is for authorized use only and is subject to monitoring, recording and audit. Unauthorized
            access and falsely identifying or submitting authentication as another person may be considered an offense
            pursuant to 18 U.S.C. Section 1001 et seq. and may result in administrative disciplinary actions and/or
            civil and criminal penalties.
          </p>
          <p className={Styles.boldText}>
            By continuing to use this system, you certify that you have read and understood the terms and conditions of
            use of this website and the contents therein.
          </p>
        </section>
      }
      footer={
        <div className={Styles.footer}>
          <Button
            variant='contained'
            onClick={() => resetPasswordContext.setResetPasswordModalOpen(false)}
            className={Styles.button}
          >
            Accept and Proceed
          </Button>
          <Button
            variant='contained'
            onClick={() => {
              resetPasswordContext.setResetPasswordModalOpen(false);
              resetPasswordContext.setCertified(false);
            }}
            className={Styles.button}
          >
            Cancel
          </Button>
        </div>
      }
    />
  );
};

export default ResetPasswordModal;
